<template>
  <v-container v-if="this.user != ''" class="my-0">
    <v-card dark class="mx-auto my-2">
      <v-card-title style="word-break: break-word"
        >{{ t("Notifications") }}<v-spacer></v-spacer>
        <v-btn icon @click="getDevicesByOwner"
          ><v-icon>mdi-refresh</v-icon></v-btn
        >
      </v-card-title>

      <v-row>
        <v-col v-for="(item, index) in devicesByOwner" :key="item.id" cols="12">
          <v-card
            color="blue-grey"
            dark
            class="mx-2 my-8"
            max-width="100%"
            tile
          >
            <v-card-title>{{ item.name }} </v-card-title>

            <v-row>
              <v-col
                xs="12"
                sm="6"
                md="6"
                lg="4"
                xl="3"
                v-for="(notification, notifIndex) in notifications[index]"
                :key="notification.id"
                cols="12"
              >
                <v-card width="90%" class="mx-auto">
                  <v-card-title style="word-break: break-word">{{
                    t(notification.spCode, notification.cn)
                  }}</v-card-title>
                  <v-card-subtitle>
                    {{
                      notification.notificationType == "newBirdAlert"
                        ? t("New Bird Alerts")
                        : ""
                    }}
                    {{ getEventText(notification.createdAt) }}
                  </v-card-subtitle>
                  <v-card-subtitle class="py-0">
                    <!-- Bird Pic -->
                    <div v-if="notification.window == 'image'">
                      <img
                        width="100%"
                        :src="
                          'https://haikubox-images.s3.amazonaws.com/' +
                          notification.spCode +
                          '.jpeg'
                        "
                        onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                      />
                    </div>

                    <!-- Spectrogram -->
                    <div v-if="notification.window == 'spec'">
                      <Plotly
                        :data="notification.spectrogram"
                        :layout="plotlyLayout"
                        :display-mode-bar="false"
                      ></Plotly>
                      <v-row no-gutters>
                        <v-col cols="1">0</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1">{{ Math.floor((notification.audioDuration || clipSeconds) / 3) }}</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1">{{ Math.floor((notification.audioDuration || clipSeconds) / 3 * 2) }}</v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="1" class="d-flex justify-end">{{ Math.ceil(notification.audioDuration || clipSeconds) }}s</v-col>
                      </v-row>
                    </div>
                  </v-card-subtitle>
                  <v-row>
                    <v-col cols="6">
                      <v-avatar
                        class="mx-4"
                        size="24"
                        v-tooltip.bottom-start="t('Image')"
                        @click="setWindowImage(notification, index, notifIndex)"
                      >
                        <img
                          :width="$vuetify.breakpoint.xs ? '100%' : '320'"
                          :src="
                            'https://haikubox-images.s3.amazonaws.com/' +
                            notification.spCode +
                            '.jpeg'
                          "
                          onerror="this.onerror=null;this.src='https://haikubox-images.s3.amazonaws.com/placeholder.jpeg';"
                        />
                      </v-avatar>
                      <v-btn
                        icon
                        v-tooltip.bottom-start="t('Spectrogram')"
                        @click="spectrogram(notification, index, notifIndex)"
                      >
                        <v-icon alt="spectrogram">mdi-chart-bubble</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        class="mx-2"
                        @click="
                          playFile(notification.wav, notification)
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Play") }}
                      </v-btn>

                      <v-btn
                        @click="
                          playFileEnhance(
                            notification.wav,
                            notification.spCode,
                            notification.cn,
                            notification.id,
                            notification
                          )
                        "
                        color="light-blue darken-1"
                      >
                        <v-icon left>mdi-play-circle</v-icon>
                        <v-divider class="mx-1" vertical></v-divider>
                        {{ t("Enhance") }}
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-card-text>
                    <v-btn
                      text
                      v-if="isBat(notification)"
                      @click="navigateTo('https://www.batcon.org/about-bats/bats-101/')"
                      color="light-blue"
                      >BCI</v-btn
                    >
                    <v-btn
                      text
                      v-if="!isBat(notification) && item.lon < -30"
                      @click="navigateTo('https://www.allaboutbirds.org/guide/' +
                            replaceSpaces(notification.cn))"
                      color="light-blue"
                      >{{ t("About") }}</v-btn
                    >
                    <v-btn
                      text
                      v-if="!isBat(notification)"
                      @click="navigateTo('https://ebird.org/species/' + notification.spCode)"
                      color="light-blue"
                      >eBird</v-btn
                    >
                    <v-btn text color="grey darken-1" @click="deleteNotification(notification.id)">{{ t("Clear") }}</v-btn>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import { API, Storage, Auth } from "aws-amplify";
import {
  notificationsBySerialByDate,
  haikuboxByOwner,
  getAudioUrl
} from "../graphql/queries";
import { deleteNotifications } from "../graphql/mutations";
import { Plotly } from "vue-plotly";
var moment = require("moment-timezone");

var fft = require("fft-js").fft,
  ifft = require("fft-js").ifft;
import { FFT } from "dsp.js";

// https://github.com/chrisguttandin/standardized-audio-context
import { AudioContext, decodeAudioData } from "standardized-audio-context";
import { unmute } from "../unmute.min.js";
let globalAudioContext = null;
let globalGainNode = null;

export default {
  name: "Settings",
  props: ["user", "email"],
      mounted() {
    // load notifications with delay because sometimes don't have user
    if (this.user == "") {
      console.log("no user....wait");
      setTimeout(async () => {
        await this.getDevicesByOwner();
      }, 2000);
    } else {
      this.getDevicesByOwner();
    }
    // get language from local storage or browser
    const haikuboxLanguage = localStorage.getItem("haikuboxLanguage");
    if (haikuboxLanguage != null) {
      this.setLanguage(haikuboxLanguage);
    } else {
      let browserLanguage = navigator.language || navigator.languages[0];
      let browserLang = browserLanguage.split("-")[0];
      // console.log("language", browserLang);
      this.setLanguage(browserLang);
    }

    if (navigator.userAgent.indexOf("gonative") > -1) {
      this.goNativeActive = true;
    }

    // Load clipSeconds from localStorage
    const savedClipSeconds = localStorage.getItem('notificationClipSeconds');
    if (savedClipSeconds) {
      this.clipSeconds = parseInt(savedClipSeconds);
      // Ensure it's a valid value
      if (this.clipSeconds < 3 || this.clipSeconds > 12 || this.clipSeconds % 3 !== 0) {
        this.clipSeconds = 3; // Default to 3 if invalid
      }
    }
  },
  components: {
    Plotly,
  },
  data() {
    return {
      numNotifications: 0,
      devicesByOwner: {},
      notifications: [],
      currentTranslations: {},
      selectedLanguage: "en",
      playbackGain: 100,
      goNativeActive: false,
      fftLength: 512,
      halfLength: 256,
      audioContextCache: new Map(),
      lastEnhancedId: "",
      lastEnhancedAudio: null,
      plotlyLayout: {
        xaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        yaxis: {
          autorange: true,
          showgrid: false,
          zeroline: false,
          showline: false,
          autotick: true,
          ticks: "",
          showticklabels: false,
          fixedrange: true,
        },
        margin: {
          l: 0,
          r: 0,
          b: 0,
          t: 0,
          pad: 4,
        },
        height: 240,
        hovermode: false,
      },
    };
  },
  methods: {
    setLanguage(lang) {
      // console.log(lang);
      if (
        (lang != "da") &
        (lang != "de") &
        (lang != "en") &
        (lang != "es") &
        (lang != "fi") &
        (lang != "fr") &
        (lang != "it") &
        (lang != "nl") &
        (lang != "no") &
        (lang != "pt") &
        (lang != "sv")
      ) {
        lang = "en";
      }
      this.loadTranslations(lang).then((translations) => {
        this.currentTranslations = translations;
      });
      this.selectedLanguage = lang;
    },
    loadTranslations(lang) {
      return fetch(`/I18N/${lang}.json`)
        .then((response) => response.json())
        .then((translations) => {
          return translations;
        });
    },
    t(key, cn) {
      return this.currentTranslations[key] || cn;
    },
    isBat(itemOrSpCode) {
      if (typeof itemOrSpCode === 'object' && itemOrSpCode !== null) {
        return itemOrSpCode.group === 'bat';
      }
      return itemOrSpCode === 'batbatbat';
    },
    navigateTo(url) {
      if(this.goNativeActive){
        window.location.href = 'gonative://window/open?url=' + url + '&mode=appbrowser';
      }
      else{
        window.open(url, '_blank');
      } 
    },
    async getDevicesByOwner() {
      if (this.user == "") {
        console.log("user not recoginized");
        return;
      }
      const devicesByOwner = await API.graphql({
        query: haikuboxByOwner,
        variables: { owner: this.user },
      });
      this.devicesByOwner = devicesByOwner.data.haikuboxByOwner.items;
      this.loadNotifications();
      // console.log("devices by owner:", this.devicesByOwner);
    },
    async loadNotifications() {
      // console.log('loadNotifications');
      let lastWeek = moment.utc().subtract(7, "days").format();
      // console.log(lastWeek);
      this.notifications = [];

      for (var i = 0; i < this.devicesByOwner.length; i++) {
        var notificationList = [];
        var nextToken = null;
        // console.log(this.devicesByOwner[i].serial);
        do {
          const filterArg = {
            serial: this.devicesByOwner[i].serial,
            createdAt: { gt: lastWeek },
            nextToken: nextToken,
          };
          const notifications = await API.graphql({
            query: notificationsBySerialByDate,
            variables: filterArg,
            limit: 24,
          });
          notificationList = notificationList.concat(
            notifications.data.notificationsBySerialByDate.items
          );
          nextToken = notifications.data.notificationsBySerialByDate.nextToken;
          // console.log('loadNotifications', notificationList, nextToken);
        } while (nextToken != null);
        notificationList.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));

        // Initialize window property for each notification
        notificationList.forEach(notification => {
          notification.window = 'image';
        });

        // // Log first notification to see structure
        // if (notificationList.length > 0) {
        //   console.log('First notification structure:', {
        //     id: notificationList[0].id,
        //     wav: notificationList[0].wav,
        //     createdAt: notificationList[0].createdAt,
        //     dt: notificationList[0].dt,
        //     updatedAt: notificationList[0].updatedAt,
        //     allFields: Object.keys(notificationList[0])
        //   });
        // }

        this.notifications.push(notificationList);
      }

      // console.log("notifications", this.notifications);
    },
    async deleteNotification(id) {
      try {
        // console.log("Deleting notification with id:", id);
        // Force token refresh
        await Auth.currentAuthenticatedUser({ bypassCache: true });
        await API.graphql({
          query: deleteNotifications,
          variables: { input: { id: id } },
        });
        // console.log("Delete result:", result);
        await this.loadNotifications();
      } catch (error) {
        console.error("Error deleting notification:", error);
        if (error.errors && error.errors.length > 0) {
          console.error("GraphQL errors:", error.errors);
          error.errors.forEach((err, index) => {
            console.error(`Error ${index + 1}:`, err.message);
          });
        }
        // Don't show alert in production, just log the error
        // alert("Failed to delete notification. Please check the console for details.");
      }
    },
    initAudioContext() {
      if (globalAudioContext == null) {
        const isIOS = /iPhone|iPod|iPad/.test(navigator.userAgent);
        if (isIOS) {
          globalAudioContext = new AudioContext();
          // Note: audioContext, allowBackgroundPlayback, forceIOSBehavior
          unmute(globalAudioContext, false, false);
        } else {
          globalAudioContext = new AudioContext();
        }
        globalGainNode = globalAudioContext.createGain();
        globalGainNode.gain.value = this.playbackGain; // Set initial volume level
        globalGainNode.connect(globalAudioContext.destination);
      }
    },
    async getAudioUrl(audioPath) {
      try {
        const audioUrlResponse = await API.graphql({
          query: getAudioUrl,
          variables: {
            audioPath: audioPath
          }
        });
        
        return audioUrlResponse.data.getAudioUrl;
      } catch (error) {
        console.error('Error getting audio URL:', error);
        throw error;
      }      
    },
    async getMatchingAudioContext(targetSampleRate) {
      // Check cache first
      if (this.audioContextCache.has(targetSampleRate)) {
        return this.audioContextCache.get(targetSampleRate);
      }
      
      // Create new context with matching sample rate
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const context = new AudioContext({ sampleRate: targetSampleRate });
      
      this.audioContextCache.set(targetSampleRate, context);
      return context;
    },
    async decodeAudioData(audioContext, arrayBuffer) {
      return new Promise((resolve, reject) => {
        audioContext.decodeAudioData(
          arrayBuffer,
          (decodedData) => resolve(decodedData),
          (error) => reject(error)
        );
      });
    },

    async playFile(audioFile, notification) {
  // console.log("playFile", audioFile);
  this.initAudioContext();

  if (globalAudioContext.state === "suspended") {
    globalAudioContext.resume();
  }

  globalGainNode.gain.value = this.playbackGain;

  // Get audio URL based on file prefix
  var audioUrl;
  if(audioFile[0] == 'b') {
    audioUrl = await this.getAudioUrl(audioFile);
  }
  else{
    audioUrl = await Storage.get(audioFile);
  }
  
  const response = await fetch(audioUrl);
  const arrayBuffer = await response.arrayBuffer();
  const audioBuffer = await globalAudioContext.decodeAudioData(arrayBuffer);

  const sampleSource = globalAudioContext.createBufferSource();
  sampleSource.buffer = audioBuffer;
  sampleSource.connect(globalGainNode);
  
  // Extract offset if available
  let startTime = 0;
  let playbackDuration = audioBuffer.duration;
  
  // For bb/ files longer than 3 seconds, use 5-second clips
  if (audioFile.startsWith('bb/') && audioBuffer.duration > 3) {
    const offset = this.extractOffsetFromWav(audioFile, notification);
    const clipDuration = 5; // Fixed 5-second clips for bb/ files
    
    if (offset > 0) {
      // Start 1 second before the offset
      startTime = offset - 1;
      console.log(`Playing ${clipDuration}s clip starting 1s before detection at ${offset}s`);
    } else {
      // No offset - start at beginning
      startTime = 0;
      console.log(`Playing ${clipDuration}s clip from beginning of file`);
    }
    
    // Ensure startTime is within bounds (handle negative offset)
    if (startTime < 0) {
      startTime = 0;
      console.log('Adjusted start time to 0 (was negative)');
    }
    
    // Ensure we don't exceed file duration
    if (startTime + clipDuration > audioBuffer.duration) {
      startTime = Math.max(0, audioBuffer.duration - clipDuration);
      console.log(`Adjusted start time to ${startTime.toFixed(1)}s to fit within file duration`);
    }
    
    playbackDuration = Math.min(clipDuration, audioBuffer.duration - startTime);
    console.log(`Final playback window: ${startTime.toFixed(1)}s - ${(startTime + playbackDuration).toFixed(1)}s`);
  } else if (audioBuffer.duration > 3) {
    // Non-bb/ files use existing logic with this.clipSeconds
    const offset = this.extractOffsetFromWav(audioFile, notification);
    
    if (offset > 0) {
      // Center window around detection
      startTime = offset - Math.floor(this.clipSeconds / 2);
      console.log(`Playing ${this.clipSeconds}s clip centered on detection at ${offset}s`);
    } else {
      // No offset - start at beginning
      startTime = 0;
      console.log(`Playing ${this.clipSeconds}s clip from beginning of file`);
    }
    
    // Ensure startTime is within bounds
    if (startTime < 0) startTime = 0;
    if (startTime + this.clipSeconds > audioBuffer.duration) {
      startTime = audioBuffer.duration - this.clipSeconds;
    }
    
    playbackDuration = this.clipSeconds;
    console.log(`Final playback window: ${startTime.toFixed(1)}s - ${(startTime + playbackDuration).toFixed(1)}s`);
  } else {
    console.log(`Playing entire short file (${audioBuffer.duration.toFixed(1)}s)`);
  }
  
  sampleSource.start(0, startTime, playbackDuration);
},


    async playFileEnhance(audioFile, spCode, cn, id, notification) {
      this.initAudioContext();
      if (globalAudioContext.state === "suspended") {
        globalAudioContext.resume();
      }

      // playing last file again
      if (this.lastEnhancedId == id && this.lastEnhancedClipSeconds == this.clipSeconds) {
        // Create an AudioBufferSourceNode
        const sourceNode = globalAudioContext.createBufferSource();
        sourceNode.buffer = this.lastEnhancedAudio;
        // Connect the source node to the AudioContext's destination (speakers)
        sourceNode.connect(globalAudioContext.destination);
        // Start playback
        sourceNode.start();
        console.log('Playing cached enhanced audio');
        return;
      }

      async function getFile(filepath) {
        const response = await fetch(filepath);
        const arrayBuffer = await response.arrayBuffer();
        const audioBuffer = await decodeAudioData(
          globalAudioContext,
          arrayBuffer
        );
        return audioBuffer;
      }

      async function setupSample(filePath) {
        const sample = await getFile(filePath);
        return sample;
      }

      // Get audio URL based on file prefix
      var getStoragePromise;
      if(audioFile[0] == 'b') {
        getStoragePromise = this.getAudioUrl(audioFile);
      }
      else{
        getStoragePromise = Storage.get(audioFile);
      }

      getStoragePromise.then((result) => {
        // console.log("Storage get", result);
        setupSample(result).then((sample) => {
          let signal = sample.getChannelData(0);
          
          // Handle offset for long files
          if (sample.duration > 3) {
        const offset = this.extractOffsetFromWav(audioFile, notification);
        let clipDuration = this.clipSeconds;
        let startOffset = Math.floor(clipDuration / 2);
        
        // For bb/ files, use 5-second clips starting 1s before offset
        if (audioFile.startsWith('bb/')) {
          clipDuration = 5;
          startOffset = 1;
        }
        
        if (offset > 0) {
          const startTime = offset - startOffset;
          console.log(`Enhancing ${clipDuration}s clip: detection at ${offset}s, processing from ${startTime.toFixed(1)}s`);
          
          let startSample = Math.floor(startTime * sample.sampleRate);
          let endSample = Math.floor((startTime + clipDuration) * sample.sampleRate);
          
          if (startSample < 0) startSample = 0;
          if (endSample > signal.length) {
            endSample = signal.length;
            startSample = Math.max(0, endSample - clipDuration * sample.sampleRate);
          }
          
          signal = signal.slice(startSample, endSample);
        } else {
          // Fallback to center if no valid offset
          const startTime = sample.duration / 2 - (clipDuration / 2);
          console.log(`No offset found, centering ${clipDuration}s enhanced clip at middle`);
          
          let startSample = Math.floor(startTime * sample.sampleRate);
          let endSample = Math.floor((startTime + clipDuration) * sample.sampleRate);
          
          if (startSample < 0) startSample = 0;
          if (endSample > signal.length) {
            endSample = signal.length;
            startSample = Math.max(0, endSample - clipDuration * sample.sampleRate);
          }
          
          signal = signal.slice(startSample, endSample);
        }
      }
          
          // Define STFT parameters
          const fftSize = 512;
          const overlap = 256;
          const hopSize = fftSize - overlap;
          // Compute the STFT
          const stft = [];
          var meanMag = new Array(fftSize).fill(0);
          var stdMag = new Array(fftSize).fill(0);
          var numStrides = 0;
          
          // Generate Hann window
          const hann = this.generateHannWindow(fftSize);
          
          for (let i = 0; i < signal.length - fftSize; i += hopSize) {
            const frame = signal.slice(i, i + fftSize);
            // Hanning Window
            for (var k = 0; k < fftSize; k++) {
              frame[k] = frame[k] * hann[k];
            }
            var phasors = fft(frame);
            // console.log(phasors);
            // store running sum of magnitude to calculate mean
            for (var j = 0; j < phasors.length; j++) {
              meanMag[j] += Math.sqrt(
                phasors[j][0] * phasors[j][0] + phasors[j][1] * phasors[j][1]
              );
            }
            numStrides++;
            stft.push([...phasors]);
          }
          // console.log('stft', stft);
          for (let j = 0; j < fftSize; j++) {
            meanMag[j] = meanMag[j] / numStrides;
          }
          // calculate SD
          // loop through each time slice
          for (let i = 0; i < stft.length; i++) {
            // loop through each frequency
            for (let j = 0; j < fftSize; j++) {
              let magnitude =
                Math.sqrt(
                  stft[i][j][0] * stft[i][j][0] + stft[i][j][1] * stft[i][j][1]
                ) - meanMag[j];
              stdMag[j] += magnitude * magnitude;
            }
          }
          for (j = 0; j < fftSize; j++) {
            stdMag[j] = Math.sqrt(stdMag[j] / numStrides);
          }
          // gate values based on mean + 2*SD
          async function gateSpectrogram() {
            for (let i = 0; i < stft.length - 4; i++) {
              // loop through each frequency
              for (let j = 0; j < fftSize; j++) {
                // get average magnitude over 5 time slices
                let magnitude =
                  (Math.sqrt(
                    stft[i][j][0] * stft[i][j][0] +
                      stft[i][j][1] * stft[i][j][1]
                  ) +
                    Math.sqrt(
                      stft[i + 1][j][0] * stft[i + 1][j][0] +
                        stft[i + 1][j][1] * stft[i + 1][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 2][j][0] * stft[i + 2][j][0] +
                        stft[i + 2][j][1] * stft[i + 2][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 3][j][0] * stft[i + 3][j][0] +
                        stft[i + 3][j][1] * stft[i + 3][j][1]
                    ) +
                    Math.sqrt(
                      stft[i + 4][j][0] * stft[i + 4][j][0] +
                        stft[i + 4][j][1] * stft[i + 4][j][1]
                    )) /
                  5;
                if (magnitude < meanMag[j] + 1.9 * stdMag[j]) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
                if (j < 4) {
                  stft[i][j][0] = stft[i][j][0] * 0.2;
                  stft[i][j][1] = stft[i][j][1] * 0.2;
                  // also flip mirror
                  stft[i][fftSize - 1 - j][0] =
                    stft[i][fftSize - 1 - j][0] * 0.2;
                  stft[i][fftSize - 1 - j][1] =
                    stft[i][fftSize - 1 - j][1] * 0.2;
                  // console.log(i, j);
                }
              }
            }
            return stft;
          }
          // Compute the ISTFT
          async function istft() {
            let recoveredSignal = new Array(signal.length).fill(0);
            let recoveredSignalComplex = new Array(fftSize);
            for (let i = 0; i < stft.length - 4; i++) {
              // console.log('before ifft', stft[i]);
              recoveredSignalComplex = ifft(stft[i]);
              // console.log('recoveredSignalComplex', recoveredSignalComplex);
              for (let j = 0; j < fftSize; j++) {
                if (i * overlap + j < signal.length) {
                  // get real part
                  recoveredSignal[i * hopSize + j] +=
                    recoveredSignalComplex[j][0];
                }
              }
            }
            return recoveredSignal;
          }
          gateSpectrogram()
            .then(() => {
              //console.log(res);
              return istft();
            })
            .then((recoveredSignal) => {
              // console.log('recoveredSignal', recoveredSignal);
              var maxSignal = 0;
              for (let i = 0; i < recoveredSignal.length - 1000; i += 1000) {
                // get stack issues so doing in chunks
                var tempMax = Math.max(...recoveredSignal.slice(i, i + 1000));
                if (tempMax > maxSignal) {
                  maxSignal = tempMax;
                }
              }
              maxSignal = 0.9 / maxSignal; // scale so can multiply to get max amp of 0.9
              // console.log('maxValue', maxSignal);
              // Create an AudioBuffer from the audio data
              const audioBuffer = globalAudioContext.createBuffer(
                1,
                recoveredSignal.length,
                sample.sampleRate
              );
              const channelData = audioBuffer.getChannelData(0);
              for (let i = 0; i < recoveredSignal.length; i++) {
                channelData[i] = recoveredSignal[i] * maxSignal;
              }
              // Create an AudioBufferSourceNode
              const sourceNode = globalAudioContext.createBufferSource();
              sourceNode.buffer = audioBuffer;
              // Connect the source node to the AudioContext's destination (speakers)
              sourceNode.connect(globalAudioContext.destination);
              // Start playback
              sourceNode.start();
              this.lastEnhancedId = id;
              this.lastEnhancedAudio = audioBuffer;
              this.lastEnhancedClipSeconds = this.clipSeconds;
            });
        });
      });
    },
    getEventText(dt) {
      let momentText = moment(dt).locale(this.selectedLanguage).fromNow();
      if (momentText == "in a few seconds") {
        momentText = "just now";
      }
      if (momentText == "a few seconds ago") {
        momentText = "just now";
      }
      return momentText;
    },
    replaceSpaces(itemWithSpaces) {
      const itemWithUnderscores = itemWithSpaces.replace(/ /g, "_");
      const itemWithApostrophe = itemWithUnderscores.replace(/'/g, "");
      // // console.log("link", itemWithUnderscores);
      return itemWithApostrophe;
    },
    updateClipSeconds(delta) {
      const newValue = this.clipSeconds + delta;
      if (newValue >= 3 && newValue <= this.maxClipSeconds) {
        this.clipSeconds = newValue;
        console.log('Updated clipSeconds to:', this.clipSeconds);
        
        // Save to localStorage
        localStorage.setItem('notificationClipSeconds', this.clipSeconds.toString());
      }
    },


    extractOffsetFromWav(wavFile, notification) {
      // Check if offsetS field is present first
      console.log(notification);
      if (notification && notification.offsetS !== undefined && notification.offsetS !== null) {
        console.log('Using offsetS field:', notification.offsetS);
        return notification.offsetS;
      }
      return 0;
    },


    setWindowImage(notification, deviceIndex, notifIndex) {
      notification.window = "image";
      notification.id += 1; // increment ID so that component updates
      this.$set(this.notifications[deviceIndex], notifIndex, notification);
    },
    generateHannWindow(length) {
      const window = new Float32Array(length);
      for (let i = 0; i < length; i++) {
        window[i] = 0.5 * (1 - Math.cos(2 * Math.PI * i / (length - 1)));
      }
      return window;
    },
    async detectSampleRate(arrayBuffer) {
      try {
        const view = new DataView(arrayBuffer);
        
        // Check file type by looking at magic bytes
        const firstFourBytes = String.fromCharCode(
          view.getUint8(0),
          view.getUint8(1), 
          view.getUint8(2),
          view.getUint8(3)
        );
        
        // WAV file detection
        if (firstFourBytes === 'RIFF') {
          // Sample rate is at bytes 24-27 (little-endian)
          const sampleRate = view.getUint32(24, true);
          // console.log('WAV file detected, sample rate:', sampleRate);
          return sampleRate;
        }
        
        // FLAC file detection
        if (firstFourBytes === 'fLaC') {
          // Look for STREAMINFO metadata block
          let offset = 4;
          
          while (offset < arrayBuffer.byteLength - 4) {
            const isLastBlock = (view.getUint8(offset) & 0x80) !== 0;
            const blockType = view.getUint8(offset) & 0x7F;
            const blockSize = (view.getUint8(offset + 1) << 16) | 
                            (view.getUint8(offset + 2) << 8) | 
                            view.getUint8(offset + 3);
            
            if (blockType === 0) { // STREAMINFO block
              const byte10 = view.getUint8(offset + 14);
              const byte11 = view.getUint8(offset + 15);
              const byte12 = view.getUint8(offset + 16);
              
              const sampleRate = (byte10 << 12) | (byte11 << 4) | (byte12 >> 4);
              // console.log('FLAC file detected, sample rate:', sampleRate);
              return sampleRate;
            }
            
            offset += 4 + blockSize;
            
            if (isLastBlock) break;
          }
        }
        
        return null;
        
      } catch (error) {
        console.error('Error detecting sample rate:', error);
        return null;
      }
    },
    async spectrogram(notification, deviceIndex, notifIndex) {
      // console.log("Spectrogram", notification.wav);

      this.initAudioContext();

      let audioFile = notification.wav;
      
      // Get audio URL based on file prefix
      let audioUrlPromise;
      if(audioFile[0] == 'b') {
        audioUrlPromise = this.getAudioUrl(audioFile);
      }
      else{
        audioUrlPromise = Storage.get(audioFile);
      }

      audioUrlPromise
        .then(async (audioUrl) => {
          try {
            // Fetch the audio file
            const response = await fetch(audioUrl);
            const arrayBuffer = await response.arrayBuffer();
            
            // Detect the sample rate (WAV or FLAC)
            let detectedSampleRate = await this.detectSampleRate(arrayBuffer);
            // console.log('Detected sample rate:', detectedSampleRate || 'using context default');
            
            // Create matching context to avoid resampling
            const audioContext = await this.getMatchingAudioContext(detectedSampleRate || 44100);
            const audioBuffer = await this.decodeAudioData(audioContext, arrayBuffer.slice(0));
            // console.log('Decoded at:', audioBuffer.sampleRate, 'Hz (detected:', detectedSampleRate, 'Hz)');
            // Store the actual audio duration
            notification.audioDuration = audioBuffer.duration;
            
            
            let signal = audioBuffer.getChannelData(0);
            const actualSampleRate = audioBuffer.sampleRate;
            
            // // Handle offset for long files
            // let startTime = 0;
            // let endTime = this.clipSeconds; // Use clipSeconds
            
            // if (audioBuffer.duration > 3) {
            //   // Calculate offset using the same method as Haikubox.vue
            //   const offset = this.extractOffsetFromWav(audioFile, notification);
              
            //   if (offset > 0) {
            //     startTime = offset - Math.floor(this.clipSeconds / 2); // Center window around detection
            //     console.log(`Spectrogram ${this.clipSeconds}s window: detection at ${offset}s, showing ${startTime.toFixed(1)}s - ${(startTime + this.clipSeconds).toFixed(1)}s`);
            //   } else {
            //     // Fallback to center if no valid offset
            //     startTime = audioBuffer.duration / 2 - (this.clipSeconds / 2);
            //     console.log(`No offset found, centering ${this.clipSeconds}s spectrogram at middle`);
            //   }
              
            //   // Ensure startTime is within bounds
            //   if (startTime < 0) startTime = 0;
            //   if (startTime + this.clipSeconds > audioBuffer.duration) {
            //     startTime = audioBuffer.duration - this.clipSeconds;
            //   }
            //   if (startTime < 0) startTime = 0;
              
            //   endTime = startTime + this.clipSeconds;
              
            //   // Extract the window
            //   const startSample = Math.floor(startTime * actualSampleRate);
            //   const endSample = Math.floor(endTime * actualSampleRate);
            //   signal = signal.slice(startSample, endSample);
              
            //   console.log(`Spectrogram final window: ${startTime.toFixed(1)}s - ${endTime.toFixed(1)}s of ${audioBuffer.duration.toFixed(1)}s file`);
            // }
            
            // FFT parameters
            const fftLength = 512; // Fixed FFT length for simplicity
            const halfLength = fftLength / 2;
            const overlap = 0.5;
            const hopSize = Math.floor(fftLength * (1.0 - overlap));
            const numTimeSteps = Math.floor((signal.length - fftLength) / hopSize) + 1;
            
            // Control frequency cutoff (show 80% of spectrum)
            const frequencyCutoff = 0.8;
            let showLength = Math.floor(halfLength * frequencyCutoff);
            
            // Adjust for specific audio files if needed
            if (audioFile[5] == "2") {
              showLength = halfLength - Math.round(0.48 * halfLength);
            }
            
            const fft = new FFT(fftLength, actualSampleRate);
            
            // Generate spectrogram - store as 2D array
            const spectrogramData = [];
            const allValues = [];
            
            // Initialize the 2D array
            for (let i = 0; i < showLength; i++) {
              spectrogramData[i] = [];
            }
            
            // Generate Hann window
            const hannWindow = this.generateHannWindow(fftLength);
            
            // Process each time window
            for (let timeStep = 0; timeStep < numTimeSteps; timeStep++) {
              const startIdx = timeStep * hopSize;
              const chunk = signal.slice(startIdx, startIdx + fftLength);
              
              // Pad with zeros if needed
              while (chunk.length < fftLength) {
                chunk.push(0);
              }
              
              // Apply Hann window
              for (let i = 0; i < fftLength; i++) {
                chunk[i] = chunk[i] * hannWindow[i];
              }
              
              // Perform FFT
              fft.forward(chunk);
              
              const scaleFactor = fftLength / 2;
              
              // Convert to dB and store
              for (let freqBin = 0; freqBin < showLength; freqBin++) {
                const value = fft.spectrum[freqBin] * scaleFactor;
                const db = 20 * Math.log10(Math.max(value, 1e-10));
                spectrogramData[freqBin][timeStep] = db;
                allValues.push(db);
              }
            }

            // Calculate percentiles for color scaling
            allValues.sort((a, b) => a - b);
            const percentile = (p) => {
              const index = Math.floor(allValues.length * p / 100);
              return allValues[Math.min(index, allValues.length - 1)];
            };
            
            const minVal = percentile(30);
            const maxVal = percentile(99);
            const dynamicRange = maxVal - minVal;
            
            // Clamp values
            for (let i = 0; i < showLength; i++) {
              for (let j = 0; j < numTimeSteps; j++) {
                spectrogramData[i][j] = Math.max(minVal, Math.min(maxVal, spectrogramData[i][j]));
              }
            }
            
            // Gaussian smoothing
            for (let i = 1; i < showLength - 1; i++) {
              for (let j = 1; j < numTimeSteps - 1; j++) {
                const smoothed = (
                  spectrogramData[i][j] * 0.4 +
                  (spectrogramData[i-1][j] + spectrogramData[i+1][j] + 
                  spectrogramData[i][j-1] + spectrogramData[i][j+1]) * 0.15
                );
                spectrogramData[i][j] = smoothed;
              }
            }

            // Improved colorscale
            const colorscale = [
              [0, "#440154"],      // Dark purple
              [0.3, "#3b528b"],    // Dark blue
              [0.7, "#21908c"],    // Teal
              [0.8, "#5dc863"],    // Green
              [0.9, "#fde725"],    // Yellow
              [1, "#ffffff"]       // White for peaks
            ];

            notification.spectrogram = [
              {
                z: spectrogramData,
                type: "heatmap",
                colorscale: colorscale,
                showscale: false,
                zmin: minVal,
                zmax: maxVal,
                zmid: minVal + dynamicRange * 0.9,
                zsmooth: 'best',
                connectgaps: false
              },
            ];

            notification.window = "spec";
            notification.id += 1; // increment ID so that component updates
            this.$set(this.notifications[deviceIndex], notifIndex, notification);
            
          } catch (err) {
            console.log(err);
            console.log("No audio", audioFile);
            return false;
          }
        })
        .catch((err) => {
          console.log("Error getting audio URL:", err);
        });
    },
  },
};
</script>